import InfoNoteText from './InfoNoteText';

const InfoNote = ({ content, setDialogOpen, setDialogContent }) => {
    return (
        <>
            <span>
                &nbsp;
            </span>

            <InfoNoteText
                onClick={() => {
                    setDialogOpen(true);
                    setDialogContent(content)
                }}
            />
        </>
    )
}

export default InfoNote;